const ThemeModule = {
    state: {
        atualizado: false
    },
    getters: {
        getAtualizado(state) {
            return state.atualizado;
        }
    },
    mutations: {
        setAtualizado(state, salva) {
            state.atualizado = salva;
        }
    },
    actions: {

    }
}

export default ThemeModule;